import React from 'react';
import { Spin } from 'antd';
import styles from './index.less';

const Loading = ({ className, tip }) => (
  <div className={`${styles.wrapper} ${className}`}>
    <Spin tip={tip} />
  </div>
);

Loading.defaultProps = {
  className: '',
  tip: null,
};

export default Loading;
